import { createContext } from 'react';

export const ModalsDispatchContext = createContext({
  open: (Component: any, props: any): void => {},
  close: (props: any): void => {},
});

export const ModalsStateContext = createContext([]);
